import TopMenu from "../../TopMenu";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import TableDocument from "../../TableDocument";
import { get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import ViewDetailsDrawerEquipment from "../../ViewDetailsDrawerEquipment";
import ViewDetailsDrawerFacility from "../../ViewDetailsDrawerFacility";

const Main = () => {
  const { user } = useUser();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [url, setUrl] = useState("/steamEquipment/steamApproveList");
  const [approvalUrl, setApprovalUrl] = useState(
    "/scope2/steamEquipment/steamApproveupdate"
  );
  const [Doc, SetDoc] = useState([]);

  const toggleData = [
    {
      title: "Consumption by Equipment",
      url: "/steamEquipment/steamApproveList",
      approvalUrl: "/scope2/steamEquipment/steamApproveupdate",
    },
    {
      title: "Consumption by Facility",
      url: "/steamFacility/steamApproveList",
      approvalUrl: "/scope2/steamFacility/steamApproveupdate",
    },
  ];

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Equipment",
      key: "equipment",
      field: "equipment",
    },
    // {
    //   title: "Brand",
    //   key: "brand",
    // },
    // {
    //   title: "Model",
    //   key: "model",
    // },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const heading2 = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Vendor",
      key: "vendor",
      field: "VendorLegalFullName",
    },
    // {
    //   title: "Previous Meter Reading",
    //   key: "previousMeterReading",
    // },
    {
      title: "Current Meter Reading",
      key: "currentMeterReading",
    },

    // {
    //   title: "Energy Consumption",
    //   key: "unitOfConsumption",
    // },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const [toggleHeding, SetHeading] = useState(heading);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "updatedAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Equipment Type": false,
    Equipment: false,
  });
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    equipmentType: [],
    industrialEquipment: [],
  });
  const viewheadersEquipment = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "equipment", title: "Equipment" },
    { key: "brand", title: "Brand" },
    { key: "model", title: "Model" },
    { key: "unitConsumption", title: "Energy Consumption" },
    { key: "usedHours", title: "Used Hours" },
    { key: "remarks", title: "Remarks" },
    // { key: "documents", title: "Documents" },
  ];

  const viewheadersFacility = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "equipment", title: "Equipment" },
    { key: "vendor", title: "Vendor" },
    { key: "previousMeterReading", title: "Previous Reading" },
    { key: "currentMeterReading", title: "Current Reading" },
    { key: "unitOfElectricityConsumption", title: "Unit Consumed" },
    { key: "multiplicationFactor", title: "Multiplication Factor" },
    { key: "reasonForDeviation", title: "Deviation Reason" },
    { key: "remarks", title: "Remarks" },
    // { key: "documents", title: "Documents" },
  ];
  const [searchQuery, setSearchQuery] = useState("");
  const [columnWidth, setcolumnWidth] = useState(
    user?.companyAdmin ? "12% 15% 15% 15% 15% 16% 8%" : "12% 20% 20% 18% 18% 8%"
  );
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope2${url}`);
      const data = response.data.data;

      const uniqueEquipment = [
        ...new Set(
          data.map((el) => el.equipment?.equipment) // Filter out undefined values
        ),
      ];
      const uniqueBrand = [
        ...new Set(
          data.map((el) => el.brand) // Filter out undefined values
        ),
      ];
      const uniqueModel = [
        ...new Set(
          data.map((el) => el.model) // Filter out undefined values
        ),
      ];
      console.log(uniqueModel, "uniqueModel");
      setFilterOptions({
        equipment: uniqueEquipment,
        brand: uniqueBrand,
        model: uniqueModel,
      });
      return {
        equipment: uniqueEquipment,
        brand: uniqueBrand,
        model: uniqueModel,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const fetchData = async (filters = filterObj) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        search: searchQuery,
        facilityList: selectedFacility.join(","),
      }).toString();
      const response = await get(
        `/scope2/${url}?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data); // Update the user list
      SetDoc(response.data.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Equipment",
      type: "option",
      key: "equipment",
      value: filterOptions.equipment,
    },
    {
      title: "Brand",
      type: "option",
      key: "brand",
      value: filterOptions.brand,
    },
    {
      title: "Model",
      type: "option",
      key: "model",
      value: filterOptions.model,
    },
    // {
    //   title: "Freight Load (Tonnes)",
    //   type: "limit",
    //   key: "load",
    //   value: ["one", "two"],
    // },
  ];

  const filterData2 = [
    { title: "Date", type: "date", key: "createdAt", value: [] },

    {
      title: "Previous Reading",
      type: "limit",
      key: "previousMeterReading",
      value: ["one", "two"],
    },
    {
      title: "Current Reading",
      type: "limit",
      key: "currentMeterReading",
      value: ["one", "two"],
    },
    {
      title: "Energy Consumption",
      type: "limit",
      key: "unitofConsumption",
      value: ["one", "two"],
    },
  ];

  useEffect(() => {
    fetchData();
  }, [
    page,
    rowsPerPage,
    sortConfig,
    searchQuery,
    filterObj,
    url,
    fromDate,
    toDate,
    selectedFacility,
  ]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    // selectedOption === "Consumption by Equipment" ?

    // setFilterObj((prev)=>{
    //   ...prev,
    //   newFilterObj
    // })
    // : setFilterObj((prev) => ({
    //   ...prev,
    //   // ...newFilterObj,
    //   ...(newFilterObj?.PreviousMeterReading && {
    //     minPreviousMeterReading: newFilterObj.PreviousMeterReading.min || undefined,
    //     maxPreviousMeterReading: newFilterObj.PreviousMeterReading.max || undefined,
    //   }),
    //   ...(newFilterObj?.CurrentMeterReading && {
    //     minCurrentMeterReading: newFilterObj.CurrentMeterReading.min || undefined,
    //     maxCurrentMeterReading: newFilterObj.CurrentMeterReading.max || undefined,
    //   }),
    //   ...(newFilterObj?.UnitConsumption && {
    //   minUnitConsumption: newFilterObj?.UnitConsumption?.min || undefined,
    //   maxUnitConsumption: newFilterObj?.UnitConsumption?.max || undefined,
    // }),
    // }))
    if (selectedOption === "Consumption by Equipment") {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj, // Directly merge newFilterObj when selectedOption matches
      }));
    } else {
      setFilterObj((prev) => ({
        ...prev,
        ...(newFilterObj?.PreviousMeterReading && {
          minPreviousMeterReading:
            newFilterObj.PreviousMeterReading.min || undefined,
          maxPreviousMeterReading:
            newFilterObj.PreviousMeterReading.max || undefined,
        }),
        ...(newFilterObj?.CurrentMeterReading && {
          minCurrentMeterReading:
            newFilterObj.CurrentMeterReading.min || undefined,
          maxCurrentMeterReading:
            newFilterObj.CurrentMeterReading.max || undefined,
        }),
        ...(newFilterObj?.UnitConsumption && {
          minUnitConsumption: newFilterObj.UnitConsumption.min || undefined,
          maxUnitConsumption: newFilterObj.UnitConsumption.max || undefined,
        }),
      }));
    }
  };

  const handleToggle = (option, url, approvalUrl) => {
    setSelectedOption(option);
    setUrl(url);
    setApprovalUrl(approvalUrl);

    SetHeading(toggleData?.[0]?.title === option ? heading : heading2);
    setcolumnWidth(
      toggleData?.[0]?.title === option
        ? user?.companyAdmin
          ? "12% 15% 15% 15% 15% 16% 8%"
          : "12% 20% 20% 18% 18% 8%"
        : user?.companyAdmin
        ? "11% 14% 13% 12% 13% 11% 14% 8%"
        : "12% 15% 13% 16% 16% 16% 8%"
    );
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0].title);
    setUrl(toggleData?.[0].url);
    setApprovalUrl(toggleData?.[0].approvalUrl);
  }, []);

  const fetchDataCallback = async () => {
    await fetchData();
  };
  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
      <>
        <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSearchQuery,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFilterModalOpen,
            toggleData,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
          }}
          heading={"Steam"}
        />
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <TableDocument
            data={Doc}
            totalPages={1}
            headers={toggleHeding}
            columnWidth={columnWidth}
            //   columnWidth={"12% 18% 20% 18% 18% 8%"}
            setsnackOpen={setsnackOpen}
            fetchDataCallback={fetchDataCallback}
            apiUrl={approvalUrl}
            // viewcolumnWidth={viewcolumnWidth}
            viewheaders={
              selectedOption === "Consumption by Equipment"
                ? viewheadersEquipment
                : viewheadersFacility
            }
            viewPage={
              selectedOption === "Consumption by Equipment"
                ? ViewDetailsDrawerEquipment
                : ViewDetailsDrawerFacility
            }
          />
        </Box>
        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={
            selectedOption === "Consumption by Equipment"
              ? filterData
              : filterData2
          }
          onFilterChange={handleFilterChange}
          title="Filter"
        />
      </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default Main;
